import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import NotificationCenter from '../Notifications/NotificationCenter';
import { useBranding } from '../../hooks/useBranding';
import { useFirmendaten } from '../../hooks/useFirmendaten';
import { getHostBranding } from '../../utils/hostBranding';
import { JarvisAvatarHeader } from '../heykiki/JarvisAvatar';

function Header() {
  const { user, logout } = useAuth();
  const { logoUrl } = useBranding();
  const { firmendaten } = useFirmendaten();

  // Firmenname aus Firmendaten oder Fallback
  const firmenname = firmendaten?.firmenname || '';
  const isHeykikiOrg = user?.organisation?.orgType === 'HEYKIKI';

  // Document-Title whitelabeln: HEYKIKI-Orgs/HeyKiki-Portal sehen nur
  // den Firmennamen bzw. Partner-Brand, reguläre Orgs weiterhin "WerkPilot"
  const hostBrand = getHostBranding();
  useEffect(() => {
    if (isHeykikiOrg || hostBrand) {
      document.title = firmenname || (hostBrand?.name || 'CRM');
    } else {
      document.title = firmenname ? `${firmenname} - WerkPilot` : 'WerkPilot';
    }
  }, [isHeykikiOrg, firmenname, hostBrand]);

  return (
    <header className="bg-surface shadow-sm border-b border-border desktop-only">
      <div className="container mx-auto px-4 lg:px-6 py-2 lg:py-4 flex justify-between items-center">
        <Link to="/dashboard" className={`flex items-center ${isHeykikiOrg ? 'gap-6' : 'gap-3'}`}>
          {isHeykikiOrg ? (
            <JarvisAvatarHeader />
          ) : (
            <img
              src={logoUrl}
              alt="Firmenlogo"
              className="h-12 lg:h-16 xl:h-20 w-auto"
            />
          )}
          <h1 className="text-xl font-serif font-bold">
            {isHeykikiOrg ? (
              <>
                {firmenname ? <><span className="text-gray-900">{firmenname}</span><span className="text-gray-400"> - </span></> : ''}
                <span className="text-gray-900">HeyKiki</span><span className="text-primary">-Portal</span>
              </>
            ) : (
              <>
                {firmenname ? <><span className="text-gray-900">{firmenname}</span><span className="text-gray-400"> - </span></> : ''}
                <span className="text-gray-900">Werk</span><span className="text-primary">Pilot</span>
              </>
            )}
          </h1>
        </Link>
        {user && (
          <div className="flex items-center gap-4">
            {/* Notification Center */}
            <NotificationCenter />

            <span className="text-sm text-text-muted">{user.name || user.email}</span>
            <button
              onClick={logout}
              className="text-sm text-danger hover:underline"
            >
              Abmelden
            </button>
          </div>
        )}
      </div>
    </header>
  );
}

export default Header;
